<script lang="ts">import Text from '../Text/Text.svelte';
// prettier-ignore
const { as = 'p', variant = 'regular', children, class: className = '', ...rest } = $props();
const mappedVariant = {
    regular: '100-r',
    bold: '100',
};
</script>

<Text {...rest} class="BodyText BodyText--{variant} {className}" {as} variant={mappedVariant[variant ?? 'regular']}>
  {@render children?.()}
</Text>
